module.exports = __webpack_public_path__ + "img/fidc-bg-3.97a027db.png";